import React, { useState } from 'react';
import { X } from 'lucide-react';
import UnifiedFilePicker from './UnifiedFilePicker';

const UnifiedFilePickerModal = ({ isOpen, onClose, onAttach, allowMultiple = false, title = "Attach Document" }) => {
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [sourceType, setSourceType] = useState(null); // 'upload' | 'library'

    if (!isOpen) return null;

    const handleFileSelect = (files, type) => {
        setSelectedFiles(files);
        setSourceType(type);
    };

    const handleAttach = () => {
        onAttach(selectedFiles, sourceType);
        onClose();
    };

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 animate-in fade-in duration-200">
            <div className="bg-white dark:bg-slate-900 rounded-2xl w-full max-w-2xl shadow-2xl overflow-hidden animate-in zoom-in-95 duration-200">
                {/* Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 dark:border-slate-700/50">
                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white">{title}</h3>
                    <button
                        onClick={onClose}
                        className="p-2 text-gray-400 dark:text-slate-500 hover:text-gray-600 hover:bg-gray-100 dark:bg-slate-800 rounded-lg transition-colors"
                    >
                        <X size={20} />
                    </button>
                </div>

                {/* Body */}
                <div className="p-6">
                    <UnifiedFilePicker onFileSelect={handleFileSelect} allowMultiple={allowMultiple} />
                </div>

                {/* Footer */}
                <div className="bg-gray-50 dark:bg-slate-800/50 px-6 py-4 flex justify-end gap-3 border-t border-gray-100 dark:border-slate-700/50">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 text-gray-600 dark:text-slate-300 font-medium hover:bg-gray-200 dark:bg-slate-700 rounded-xl transition-colors"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleAttach}
                        disabled={selectedFiles.length === 0}
                        className="px-6 py-2 bg-primary text-white font-medium rounded-xl hover:bg-primary-dark shadow-md shadow-primary/25 disabled:opacity-50 disabled:shadow-none transition-all"
                    >
                        Attach {selectedFiles.length > 0 ? `(${selectedFiles.length})` : ''}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UnifiedFilePickerModal;
